import React, { useEffect, useState, useCallback } from "react";
import "../Notification/Notification.css";
import { getNotifications, notificationHistory } from "../api/api";
import moment from "moment";

const Notifications = () => {
  const [notificationData, setnotificationData] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const formatTime = (timestamp) => {
    const now = moment();
    const notificationTime = moment(timestamp);
    const diffInSeconds = now.diff(notificationTime, "seconds");
    const diffInMinutes = now.diff(notificationTime, "minutes");
    const diffInHours = now.diff(notificationTime, "hours");
    const diffInDays = now.diff(notificationTime, "days");
    const diffInMonths = now.diff(notificationTime, "months");
    const diffInYears = now.diff(notificationTime, "years");

    if (diffInSeconds < 60) return "Just now";
    if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    if (diffInHours < 24) return `${diffInHours} hr ago`;
    if (diffInDays < 30) return `${diffInDays} d ago`;
    if (diffInMonths < 12) return `${diffInMonths} m ago`;
    return `${diffInYears} y ago`;
  };

  // Fetch Notifications
  const fetchNotifications = async () => {
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData1 = JSON.parse(userData);
      const _id = parsedUserData1?._id || parsedUserData1?.id;
      const values = {
        user_id: _id,
      };
      console.log("notification Page", values);
      const getNotification = await notificationHistory(values);
      console.log("api44444", JSON.stringify(getNotification));
      setnotificationData(getNotification);
    } catch {
      console.log("notification Console");
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    fetchNotifications().then(() => setRefreshing(false));
  }, []);

  // Render each notification
  const renderNotification = (item) => (
    <div className="notification-item" key={item.id}>
      <div className="notification-content">
        <h4 className="sender">{item?.title}</h4>
        <p className="message">{item?.message}</p>
      </div>
      <div className="time">{formatTime(item?.created_at)}</div>
    </div>
  );

  return (
    <div className="container">
      {/* <div className="profile-card"> */}
      <div className="profile-header">Notifications</div>
      {/* </div> */}
      {notificationData?.notification_history?.length > 0 ? (
        <div className="notification-scroll-wrapper">

          {/* <button className="refresh-button" onClick={onRefresh}>
            {refreshing ? "Refreshing..." : "Refresh"}
          </button> */}
          {notificationData.notification_history.map(renderNotification)}
        </div>
      ) : (
        <div className="no-data-container">
          <p className="no-data-text">No Notifications Available</p>
        </div>
      )}
    </div>
  );
};

export default Notifications;

